// @flow
import type { Untranslated } from '@rover/shared/js/types/Translation';
import type { ErrorContext } from '@rover/react-lib/types/ErrorContext';
import { captureException, withScope } from '@rover/utilities/sentry';

type StripeError = {| type: string, message: string, code: string |};
export type ErrorType = Error | Untranslated | StripeError | {| id: string |};

const IS_DEV = process.env.NODE_ENV === 'development';

function getErrorObject(error: ErrorType): Error {
  if (typeof error === 'string') {
    return new Error(error);
  }
  if (error instanceof Error) {
    return error;

    // Special handling for Stripe SDK errors
    // they are thrown like errors, but are not
    // instances of the Error prototype
  }
  if (
    typeof error.type === 'string' &&
    typeof error.message === 'string' &&
    typeof error.code === 'string'
  ) {
    return new Error(`${error.type}: ${error.code} - ${error.message}`);
  }
  if (error.id) {
    return new Error(error.id);
  }
  return new Error(error);
}

const reportError = (
  error: ErrorType,
  errorContext?: ErrorContext,
  tracingId?: string = '',
  logPrefix?: string = ''
) => {
  const errorObject: Error = getErrorObject(error);

  // Replace newlines with '#012' to convert to rsyslog format
  const errorStackTrace = IS_DEV ? errorObject.stack : errorObject.stack.replace(/\n/g, '#012');
  const logLine = `${logPrefix}${tracingId}${errorStackTrace}`;

  console.error(logLine); // eslint-disable-line no-console

  if (IS_DEV) throw errorObject;

  withScope(scope => {
    scope.setExtras({ stacktrace: errorObject.stack });
    captureException(errorObject, errorContext);
  });
};

export default reportError;



// WEBPACK FOOTER //
// ../utilities/reportError/reportError.js